<template>
  <v-dialog v-model="shown" width="700">
    <v-form>
      <v-card>
        <v-card-title class="mb-5 primary white--text">
          <h2 class="my-5">{{ category.id ? 'Update Event Category' : 'New Event Category' }}</h2>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="category.name" label="Category name" />
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="shown = false"
            color="error"
            large
          >
            Cancel
          </v-btn>
          <v-btn
            @click="addOrUpdateCategory"
            color="accent"
            large
          >
            {{ category.id ? 'Update' : 'Submit' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

export default {
  data: () => ({
    category: {
      id: null,
      name: ''
    },
    shown: false
  }),
  mounted () {
    this.$root.$on('showEventCategoryEditor', (category) => {
      if (category) {
        this.category = JSON.parse(JSON.stringify(category))
      } else {
        this.category = {
          id: null,
          name: ''
        }
      }
      this.shown = true
    })
  },
  methods: {
    ...mapMutations(['setGlobalNotification']),
    ...mapActions(['firestoreUpdateEventCategory', 'firestoreAddEventCategory']),
    async addOrUpdateCategory () {
      if (this.category.id) {
        console.log('Updating event category', this.category)
        try {
          await this.firestoreUpdateEventCategory(this.category)
          this.setGlobalNotification({ val: 'Event category updated.' })
        } catch (err) {
          console.log(err)
          this.setGlobalNotification({ val: 'Error updating event category.', type: 'error' })
          return
        }
      } else {
        console.log('Saving new event category', this.category)
        try {
          await this.firestoreAddEventCategory(this.category)
          this.setGlobalNotification({ val: 'Added new event category.' })
        } catch (err) {
          console.log(err)
          this.setGlobalNotification({ val: 'Error adding new event category.', type: 'error' })
          return
        }
      }
      this.category = {
        id: null,
        name: ''
      }
      this.shown = false
    }
  },
  watch: {
    shown (val) {
      if (!val) {
        this.category = {
          id: null,
          name: ''
        }
      }
    }
  }
}
</script>
